window.addEventListener('DOMContentLoaded', function(e) {

    // onpageshow = event => { };
    
    let checkbox_container = document.querySelector('.checkbox-container');
    if(checkbox_container){
        let checkboxes = checkbox_container.querySelectorAll('input[type=checkbox].category-cb');
        let checkbox_all = checkbox_container.querySelector('#checkbox-all');
        let projects = document.querySelectorAll('.projects-container .project');

        //get filter param from other page then apply that filter
        let url_param = location.search;
        let filter_val = url_param.split('filters=')[1];
        if(filter_val){
            let checkbox_selected = document.querySelector(`input[type=checkbox][data-category=${filter_val}]`)
            if(checkbox_selected){
                checkbox_all.checked = false;
                //remove all old active project
                removeAllActiveProject();

                checkbox_selected.checked = true;
                //add/remove the selected project
                let project_relateds = document.querySelectorAll(`.projects-container .${filter_val}`);
                project_relateds.forEach(project=>{
                    project.classList.add('active');
                })

            }else{
                checkbox_all.checked = true;
            }
            
        }

        addEventListener('pageshow', event => {
            const checked_cbs_elements = checkbox_container.querySelectorAll('input:checked');
            if(checked_cbs_elements.length < 1 || (checked_cbs_elements.length == 1 && checked_cbs_elements[0].id == 'checkbox-all')){
                checkbox_all.checked = true;
                projects.forEach(project =>{
                    project.classList.add('active')
                })
            }else{
                checked_cbs_elements.forEach(checked_cb => {
                    checkbox_all.checked = false;
                    //remove all old active project
                    removeAllActiveProject();
                    //add/remove the selected project
                    let project_relateds = document.querySelectorAll(`.projects-container .${checked_cb.dataset.category}`)
                    project_relateds.forEach(project=>{
                        if(checked_cb.checked == true){
                            project.classList.add('active');
                        }
                    })
                    
                });
            }
            
         });


        //select checkbox handle
        checkboxes.forEach(cb=>{
            cb.addEventListener('change',()=>{
                 checkbox_all.checked = false;
                 //remove all old active project
                 removeAllActiveProject();
                
                let checked_cbs = checkbox_container.querySelectorAll('input:checked');
                if(checked_cbs.length < 1){
                    checkbox_all.checked = true;
                    projects.forEach(project =>{
                        project.classList.add('active')
                    })
                }else{
                    checked_cbs.forEach(checked_cb =>{
                        //add/remove the selected project
                        let project_relateds = document.querySelectorAll(`.projects-container .${checked_cb.dataset.category}`)
                        project_relateds.forEach(project=>{
                            if(checked_cb.checked == true){
                                project.classList.add('active');
                            }
                        })
                    })
                }
                
            })
        })

        //checkbox all handle
        checkbox_all.addEventListener('change',()=>{
            if(checkbox_all.checked == true){
                checkboxes.forEach(cb=>{
                    cb.checked = false;
                    projects.forEach(project =>{
                        project.classList.add('active')
                    })
                })
            }else{
                checkbox_all.checked = true;
            }
        })
        //clear
        let clear = document.querySelector('.clear');
        if(clear){
            clear.addEventListener('click', ()=>{
                checkboxes.forEach(cb=>{
                    cb.checked = false;
                    projects.forEach(project =>{
                        project.classList.add('active')
                    })
                })
                checkbox_all.checked = true;
            })
        }

        function removeAllActiveProject(){
            projects.forEach(pr =>{
                pr.classList.remove('active')
            })
        }
        
    }

})